import React, { useState, useEffect, useRef } from 'react';
import '../style/Shoutout.css';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { IoMdCloseCircleOutline } from 'react-icons/io';
import Spinner from 'react-bootstrap/Spinner';
import { fetchWithAuth } from './authService';
import { API_ENDPOINTS } from '../utils/constants';
import { Navigate, useNavigate } from 'react-router-dom';

const ShoutoutModal = ({
  isOpen,
  onClose,
  venueId,
  onSuccess,
  venueDetails,
}) => {
  const [occasions, setOccasions] = useState([]);
  const [isCustomizable, setIsCustomizable] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [formData, setFormData] = useState({
    occasion: localStorage.getItem('selectedMessage') || 'Happy Birthday',
    name: localStorage.getItem('shoutOutName') || '',
    description: '',
    isMidnightShoutOut: false,
  });
  const [photoSrc, setPhotoSrc] = useState('');
  const [avatarUploading, setAvatarUploading] = useState(false);
  const [hoverLogo, setHoverLogo] = useState(false);
  const photoInputRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);
  const [isError, setIsError] = useState(false);
  const shoutOutCost = localStorage.getItem('shoutOutCost') || 100;
  const [profile, setProfile] = useState({});
  const [photoFile, setPhotoFile] = useState(null);
  const [showDescription, setShowDescription] = useState(false);
  const navigate = useNavigate();
  const cancelMsg = () => {
    setIsError(false);
  };
  const [showModal, setShowModal] = useState(false);
  const [price, setPrice] = useState([]);
  useEffect(() => {
    const selectedMessage = localStorage.getItem('selectedMessage');
    if (selectedMessage) {
      setFormData(prev => ({ ...prev, occasion: selectedMessage }));
    }
    const fetchPrice = async () => {
      try {
        const response = await fetchWithAuth(
          API_ENDPOINTS.ORDER_PRICE_BY_VENUE(localStorage.getItem('vId'))
        );
        if (!response.ok) throw new Error('Failed to fetch price');

        const data = await response.json();
        // Filter out hidden packs
        const visiblePacks = data.filter(pack => !pack.isHidden);
        console.log('Visible Packs:', visiblePacks);
        setPrice(visiblePacks);
      } catch (error) {
        console.error('Error fetching prices:', error);
      }
    };
    fetchPrice();
  }, []);

  useEffect(() => {
    // Restore name when modal reopens
    const savedName = localStorage.getItem('shoutOutName');
    if (savedName) {
      setFormData(prev => ({ ...prev, name: savedName }));
    }
  }, [isOpen]);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const response = await fetchWithAuth(API_ENDPOINTS.USERS, {
          method: 'GET',
        });

        if (!response.ok) throw new Error('Failed to fetch data');

        const data = await response.json();
        console.log(data);
        setProfile(data);
        setFormData({
          ...formData,
          from: data.first_name ? data.first_name : '',
        }); // Set the from field here
        console.log('Profile fetched:', data);
      } catch (error) {
        console.error('Error fetching songs:', error);
      }
    };

    fetchProfile();
  }, [isOpen]);

  // Fetch occasions from API
  useEffect(() => {
    const fetchOccasions = async () => {
      try {
        const response = await fetchWithAuth(API_ENDPOINTS.SHOUTOUT_MESSAGES, {
          method: 'GET',
        });

        if (!response.ok) throw new Error('Failed to fetch occasions');

        const data = await response.json();
        setOccasions(data.messages || []);
        setIsCustomizable(data.isCustomizable || false);

        // Set default occasion if available
        if (data.messages && data.messages.length > 0) {
          setFormData(prev => ({ ...prev, occasion: data.messages[0] }));
        }
        if (localStorage.getItem('selectedMessage')) {
          setFormData({
            ...formData,
            occasion: localStorage.getItem('selectedMessage'),
          });
        }
      } catch (error) {
        console.error('Error fetching occasions:', error);
      }
    };

    if (isOpen) {
      fetchOccasions();
    }
  }, [isOpen]);

  const handleFileChange = async e => {
    const file = e.target.files[0];
    if (file) {
      setAvatarUploading(true);

      // Convert file to base64 instead of blob URL
      const reader = new FileReader();
      reader.onloadend = () => {
        setPhotoFile(file);
        setPhotoSrc(reader.result); // base64 string
        localStorage.setItem('shoutOutImage', reader.result); // save base64
        setAvatarUploading(false);
      };
      reader.readAsDataURL(file);
    }
  };

  // Restore saved image (on modal open or refresh)
  // Restore saved image (on modal open or refresh)
  useEffect(() => {
    const savedImage = localStorage.getItem('shoutOutImage');
    if (savedImage) {
      setPhotoSrc(savedImage);

      // 🔥 Rebuild a File object so photoFile isn't null
      const byteString = atob(savedImage.split(',')[1]);
      const mimeString = savedImage.split(',')[0].split(':')[1].split(';')[0];
      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      const blob = new Blob([ab], { type: mimeString });
      const restoredFile = new File([blob], 'restored-image.jpg', {
        type: mimeString,
      });

      setPhotoFile(restoredFile); // ✅ photoFile available again
    }
  }, [isOpen]);

  const handleChange = e => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));

    // Save name to localStorage as user types
    if (name === 'name') {
      localStorage.setItem('shoutOutName', value);
    }
  };

  async function uploadShoutoutImage(shoutoutId, file) {
    const formData = new FormData();
    formData.append('picture', file);
    const token = localStorage.getItem('tringAuthToken');

    try {
      const response = await fetch(
        API_ENDPOINTS.SHOUTOUT_PICTURE_UPLOAD(shoutoutId),
        {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: formData,
        }
      );

      if (!response.ok) throw new Error('Image upload failed');

      const data = await response.json(); // ✅ consume once
      console.log('Image upload response:', data);

      // Clear temp data only after success
      localStorage.removeItem('shoutOutImage');
      setPhotoSrc('');
      setPhotoFile(null);

      return data;
    } catch (error) {
      toast.error('Image upload failed');
      console.error('Image upload error:', error);
    }
  }

  const handleSubmit = async e => {
    e.preventDefault();
    setIsLoading(true);

    // Validate required fields
    if (!formData.name.trim()) {
      setIsLoading(false);
      setErrorMsg('Please fill in the name');
      setIsError(true);
      return;
    }

    if (!formData.occasion) {
      setIsLoading(false);
      setErrorMsg('Please select an occasion');
      setIsError(true);
      return;
    }

    const token = localStorage.getItem('tringAuthToken');
    if (!token) {
      console.error('No auth token found');
      setIsLoading(false);
      setErrorMsg('Authentication required');
      setIsError(true);
      return;
    }

    if (!venueId) {
      console.error('No venueId found');
      setIsLoading(false);
      setErrorMsg('No venue found');
      setIsError(true);
      return;
    }

    try {
      const shoutoutresponse = await fetchWithAuth(
        API_ENDPOINTS.SHOUTOUT_REQUEST(venueId),
        {
          method: 'POST',
          body: JSON.stringify({
            shoutOut: `${formData.occasion} ${formData.name}`,
            wish: `${formData.occasion}`,
            recipientName: `${formData.name}`,
            additionalInfo: formData.description || '',
            isMidnightShoutOut: formData.isMidnightShoutOut,
          }),
        }
      );

      if (!shoutoutresponse.ok) {
        const errorData = await shoutoutresponse.json();
        const errormsg =
          errorData?.message || errorData?.error || 'Something went wrong';
        setIsLoading(false);
        setErrorMsg(errormsg.toString());
        setIsError(true);
        return;
      }
      const responseData = await shoutoutresponse.json();
      console.log('Shoutout Success Response:', responseData);
      console.log('photoFile:', photoFile);
      if (photoFile) {
        await uploadShoutoutImage(responseData.id, photoFile);
      }

      setIsLoading(false);
      toast.success('Shout-Out Request Sent Successfully!');
      // Reset form and close modal
      setFormData({
        occasion: occasions.length > 0 ? occasions[0] : '',
        name: '',
        description: '',
      });
      onClose();
      if (onSuccess) onSuccess();
      setShowConfirm(false);
      localStorage.removeItem('shoutOutName');
      setPhotoFile(null);
    } catch (error) {
      console.error('Error sending request:', error);
      setIsLoading(false);
      setErrorMsg('Failed to send shout-out');
      setIsError(true);
    }
  };

  const handleSendClick = () => {
    // Validate required fields

    if (venueDetails.status !== 'active') {
      setIsError(true);
      if (venueDetails.isKJVenue)
        setErrorMsg("Hold up! Shoutouts start when we're live");
      else setErrorMsg("DJ's taking a break, request will open soon");
      return;
    }
    if (!formData.name.trim()) {
      setErrorMsg('Please fill in the name');
      setIsError(true);
      return;
    }
    if (!formData.occasion) {
      setErrorMsg('Please select an occasion');
      setIsError(true);
      return;
    }

    if (profile.coins < shoutOutCost) {
      navigate('/insufficient-coins', {
        state: {
          shoutOutDetails: {
            occasion: formData.occasion,
            name: formData.name,
            description: formData.description,
            isMidnightShoutOut: formData.isMidnightShoutOut,
          },
          cost: shoutOutCost,
          priceData: price,
          walletCoins: profile.coins,
        },
      });
      return;
    }
    setShowConfirm(true);
  };

  // Toggle description with upward shift
  const toggleDescription = () => {
    setShowDescription(!showDescription);
  };

  if (!isOpen) return null;

  return (
    <>
      <ToastContainer position="top-center" autoClose={3000} />
      {/* Modal Overlay - Base Layer */}
      <div
        onClick={onClose}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 1000, // Base modal layer
        }}
      >
        <div
          onClick={e => e.stopPropagation()}
          style={{
            position: 'fixed',
            bottom: 0,
            left: 0,
            right: 0,
            backgroundColor: 'white',
            borderRadius: '20px 20px 0 0',
            padding: '20px 24px 20px 24px',
            boxShadow: '0 -4px 20px rgba(0,0,0,0.1)',
            display: 'flex',
            flexDirection: 'column',
            animation: 'slideUp 0.3s ease-out',
            maxHeight: '80vh',
            transition: 'height 0.3s ease-out',
            overflowY: 'auto',
          }}
        >
          {/* Header */}
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              marginBottom: '1rem',
              position: 'relative',
            }}
          >
            <div
              style={{
                width: '50px',
                height: '4px',
                backgroundColor: '#E0E0E0',
                borderRadius: '2px',
                position: 'absolute',
                top: '-15px',
                left: '50%',
                transform: 'translateX(-50%)',
              }}
            />
            <h3
              style={{
                color: '#D0151C',
                fontSize: '20px',
                fontWeight: '600',
                margin: 0,
              }}
            >
              Add a Shout-out
            </h3>
            <button
              onClick={onClose}
              style={{
                position: 'absolute',
                right: 0,
                background: 'transparent',
                border: 'none',
                fontSize: '24px',
                color: '#999',
                cursor: 'pointer',
              }}
            >
              ×
            </button>
          </div>

          {/* Form Content */}
          <div
            style={{
              flexGrow: 1,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
            }}
          >
            <input
              type="file"
              ref={photoInputRef}
              onChange={handleFileChange}
              accept="image/png, image/jpeg, image/jpg, image/webp"
              style={{ display: 'none' }}
            />
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignContent: 'center',
              }}
            >
              <div
                style={{
                  width: 80,
                  height: 80,
                  borderRadius: '50%',
                  border: `2px ${photoSrc ? 'solid' : 'dashed'} ${
                    hoverLogo ? '#DC143C' : '#cbd5e0'
                  }`,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  background: 'linear-gradient(135deg, #f8fafc, #edf2f7)',
                }}
                onMouseEnter={() => setHoverLogo(true)}
                onMouseLeave={() => setHoverLogo(false)}
                title={avatarUploading ? 'Uploading...' : 'Add your photo'}
                onClick={() => photoInputRef.current?.click()}
              >
                {avatarUploading ? (
                  <Spinner animation="border" size="sm" variant="primary" />
                ) : photoSrc ? (
                  <img
                    alt="Uploaded avatar"
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      borderRadius: '50%',
                    }}
                    src={photoSrc}
                  />
                ) : (
                  <svg
                    fill="currentColor"
                    viewBox="0 0 24 24"
                    width="20"
                    height="20"
                    style={{
                      color: hoverLogo ? '#DC143C' : '#a0aec0',
                      transition: 'color 0.3s ease',
                    }}
                  >
                    <path d="M12 9a3 3 0 100 6 3 3 0 000-6zm0-2a5 5 0 110 10 5 5 0 010-10zm0-4a1 1 0 00-.707.293L9.586 5H7a3 3 0 00-3 3v8a3 3 0 003 3h10a3 3 0 003-3V8a3 3 0 00-3-3h-2.586l-1.707-1.707A1 1 0 0012 3z" />
                  </svg>
                )}
              </div>
            </div>
            <p
              style={{
                marginTop: '0.6rem',
                marginBottom: '1rem',
                color: '#999999',
              }}
            >
              Add Photo (optional)
            </p>
            <div>
              {/* Select Occasion */}
              <div style={{ marginBottom: '0.7rem' }}>
                <label
                  style={{
                    display: 'block',
                    marginBottom: '0.5rem',
                    color: '#D0151C',
                    fontSize: '16px',
                    fontWeight: '600',
                    textAlign: 'left',
                  }}
                >
                  Select Occasion
                </label>
                <button
                  name="occasion"
                  onClick={() => {
                    navigate('/shout-out-options');
                  }}
                  style={{
                    width: '100%',
                    padding: '8px',
                    borderRadius: '12px',
                    fontSize: '16px',
                    textAlign: 'start',
                    border: '1px solid #E0E0E0',
                    backgroundColor: 'white',
                    color: '#333',
                    appearance: 'none',
                    backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e")`,
                    backgroundPosition: 'right 12px center',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: '16px',
                    boxSizing: 'border-box',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '9px',
                    }}
                  >
                    <img
                      src={
                        localStorage.getItem('selectedThumbnail') ||
                        'https://images.tringbox.com/events/hb.png'
                      }
                      alt="occasion"
                      style={{
                        width: '24px',
                        height: '24px',
                        objectFit: 'cover',
                        borderRadius: '4px',
                      }}
                    />
                    <span>
                      {localStorage.getItem('selectedMessage') ||
                        formData.occasion}
                    </span>
                  </div>
                </button>
              </div>

              {/* Name */}
              <div style={{ marginBottom: '0.6rem' }}>
                <label
                  style={{
                    display: 'block',
                    marginBottom: '0.5rem',
                    color: '#D0151C',
                    fontSize: '16px',
                    fontWeight: '600',
                    textAlign: 'left',
                  }}
                >
                  Name
                </label>
                <input
                  type="text"
                  name="name"
                  placeholder="Name of the Person"
                  value={formData.name}
                  maxLength={14}
                  onChange={handleChange}
                  style={{
                    width: '100%',
                    padding: '8px',
                    borderRadius: '12px',
                    fontSize: '16px',
                    border: '1px solid #E0E0E0',
                    boxSizing: 'border-box',
                    color: '#333',
                  }}
                />
                {formData.name.length >= 14 && (
                  <p
                    style={{
                      color: '#E31837',
                      fontSize: '14px',
                      marginTop: '6px',
                    }}
                  >
                    Name must not exceed 14 characters
                  </p>
                )}
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginTop: '11px',
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    {(() => {
                      const currentHour = new Date().getHours();
                      if (currentHour >= 4) {
                        return (
                          <>
                            <input
                              type="checkbox"
                              id="midnightShoutOut"
                              name="isMidnightShoutOut"
                              checked={formData.isMidnightShoutOut}
                              onChange={handleChange}
                              style={{
                                marginRight: '6px',
                                width: '16px',
                                height: '16px',
                                accentColor: '#D0151C',
                              }}
                            />
                            <label
                              htmlFor="midnightShoutOut"
                              style={{ fontSize: '14px', color: '#666' }}
                            >
                              Announce after 12 AM
                            </label>
                          </>
                        );
                      }
                      return null;
                    })()}
                  </div>

                  {!showDescription && (
                    <div>
                      <button
                        type="button"
                        onClick={toggleDescription}
                        style={{
                          background: 'transparent',
                          border: 'none',
                          color: '#D0151C',
                          fontSize: '14px',
                          cursor: 'pointer',
                          padding: '0',
                        }}
                      >
                        Say more
                      </button>
                    </div>
                  )}
                </div>
              </div>

              {/* Description Field (conditionally shown) */}
              {showDescription && (
                <div style={{ marginBottom: '0.4rem' }}>
                  {' '}
                  {/* Reduced from 0.8rem to 0.4rem */}
                  <label
                    style={{
                      display: 'block',
                      marginBottom: '0.5rem',
                      color: '#D0151C',
                      fontSize: '16px',
                      fontWeight: '600',
                      textAlign: 'left',
                    }}
                  >
                    Description
                  </label>
                  <input
                    type="text"
                    name="description"
                    value={formData.description}
                    placeholder="What is so special about this person"
                    onChange={handleChange}
                    style={{
                      width: '100%',
                      padding: '8px',
                      borderRadius: '12px',
                      fontSize: '16px',
                      border: '1px solid #E0E0E0',
                      boxSizing: 'border-box',
                      color: '#333',
                    }}
                  />
                </div>
              )}
            </div>

            {/* Send Button with conditional top margin */}
            <div style={{ marginTop: '0.5rem' }}>
              {' '}
              {/* Reduced margin when description is shown */}
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '100%',
                }}
              >
                <button
                  type="button"
                  onClick={handleSendClick}
                  style={{
                    width: '90%',
                    padding: '16px 16px',
                    color: 'white',
                    background:
                      'linear-gradient(90deg, #CB151F 0%, #873662 100%)',
                    borderRadius: '12px',
                    border: 'none',
                    fontSize: '16px',
                    fontWeight: '600',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '10px',
                  }}
                >
                  <span style={{ fontSize: '18px' }}>
                    <img
                      src="/images/coin.svg"
                      style={{
                        width: '23px',
                        height: '23px',
                        aspectRatio: '1/1',
                      }}
                    />
                  </span>
                  Send Shout-Out
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Error Modal - Higher Layer */}
      {isError && (
        <div className="eoverlay" style={{ zIndex: 2000 }}>
          <div className="eoverlay" onClick={cancelMsg}></div>
          <div className="emodalecontent">
            <div
              className="w-100 p-3 d-flex flex-row"
              style={{
                borderRadius: '15px 15px 0px 0px',
                background: 'linear-gradient(90deg, #C91721 0%, #8A325D 100%)',
              }}
            >
              <div className="col-12 d-flex flex-row justify-content-between">
                <span></span>
                <h3 className="m-0" style={{ color: 'white' }}>
                  Message
                </h3>
                <button
                  style={{
                    color: 'white',
                    background: 'transparent',
                    border: 'none',
                  }}
                  onClick={cancelMsg}
                >
                  <IoMdCloseCircleOutline
                    style={{ color: 'white', fontSize: '25px' }}
                  />
                </button>
              </div>
            </div>
            <div className="w-100">
              <div
                className="p-3 w-100"
                style={{
                  background: '#FFF',
                  borderRadius: '0px 0px 15px 15px',
                }}
              >
                <span>
                  {typeof errorMsg === 'string'
                    ? errorMsg
                    : errorMsg?.message || 'Error occurred'}
                </span>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Loading Modal - Higher Layer */}
      {isLoading && (
        <div className="lmodale" style={{ zIndex: 2100 }}>
          <div className="loverlay"></div>
          <div className="lmodalecontent">
            <Spinner animation="border" role="status" style={{ color: 'red' }}>
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        </div>
      )}

      {/* Confirmation Modal - Highest Layer */}
      {showConfirm && profile.coins >= shoutOutCost && !showModal && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100dvh',
            background: 'rgba(0,0,0,0.6)', // Darker overlay for better contrast
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backdropFilter: 'blur(4px)', // Stronger blur
            zIndex: 3000, // Highest priority layer
          }}
          onClick={() => setShowConfirm(false)}
        >
          <div
            style={{
              background: '#fff',
              borderRadius: '22px',
              maxWidth: 370,
              width: '90%',
              boxShadow: '0 8px 40px rgba(0,0,0,0.3)', // Stronger shadow
              overflow: 'hidden',
              position: 'relative',
            }}
            onClick={e => e.stopPropagation()}
          >
            <div
              style={{
                background: 'linear-gradient(90deg,#c91721 0%,#8a325d 100%)',
                padding: '18px 0 12px 0',
                textAlign: 'center',
              }}
            >
              <div
                style={{
                  color: 'white',
                  fontWeight: 600,
                  fontSize: 20,
                  letterSpacing: '.02em',
                }}
              >
                Shoutout Request
              </div>
            </div>

            <div
              style={{
                padding: '16px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                background: '#fff',
                borderBottom: '1px solid #F1F1F1',
              }}
            >
              <div
                style={{ display: 'flex', alignItems: 'center', gap: '12px' }}
              >
                <div style={{ fontSize: 18, fontWeight: 500, color: '#222' }}>
                  Make them feel special💖
                </div>
              </div>
              <div style={{ textAlign: 'center' }}>
                <img
                  src="/images/coin.svg"
                  alt="coin"
                  style={{
                    width: 30,
                    height: 30,
                    marginBottom: 4,
                  }}
                />
                <div
                  style={{
                    color: '#9F2A4A',
                    fontSize: 16,
                    fontWeight: 600,
                  }}
                >
                  {shoutOutCost} coins
                </div>
              </div>
            </div>

            <div
              style={{
                borderTop: '0.5px solid black',
                display: 'flex',
              }}
            >
              <button
                style={{
                  flex: 1,
                  border: 'none',
                  background: '#fff',
                  borderRadius: '0 0 0 22px',
                  fontSize: 17,
                  color: '#C91721',
                  padding: '15px 0',
                  fontWeight: 500,
                  cursor: 'pointer',
                }}
                onClick={() => setShowConfirm(false)}
              >
                Cancel
              </button>
              <button
                style={{
                  flex: 1,
                  borderRadius: '0 0 22px 0',
                  border: '0.5px solid #CC151E',
                  fontSize: 17,
                  fontWeight: 500,
                  color: '#fff',
                  cursor: 'pointer',
                  background:
                    'linear-gradient(90deg, #CC151E -18.35%, #873662 108.23%)',
                }}
                onClick={handleSubmit}
              >
                Send Now
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ShoutoutModal;
